// Collection-card hearts (Swym).
// - Swym saves and removes the product's first variant, even when it is sold out. When no variant is given, save the
//   first available one (products with nothing in stock keep Swym's default). Removing clears every saved variant of
//   the product, like the product page heart. Swym re-assigns its API after load, so the patch is applied on each card-heart click, before
//   Swym handles it.
// - Swym repaints the heart only once its request returns (about a second later), so after a click the heart looked
//   unchanged as soon as the pointer left it. Show the new state on click; Swym's repaint then confirms it.
(() => {
  const noop = () => {};
  const handleOf = (url) => new URL(url, window.location.origin).pathname.split('/products/')[1];

  const patch = (swat) => {
    const addToWishlistUsingDu = swat.addToWishlistUsingDu;
    const removeFromWishlistUsingDu = swat.removeFromWishlistUsingDu;
    if (typeof addToWishlistUsingDu !== 'function' || addToWishlistUsingDu.availableVariantPatch) return;

    const add = function (product, onSuccess, onError) {
      if (!product?.du || product.epi) return addToWishlistUsingDu.apply(this, arguments);

      const save = (epi) => addToWishlistUsingDu.call(this, epi ? { ...product, epi } : product, onSuccess, onError);
      fetch(`${new URL(product.du, window.location.origin).pathname}.js`)
        .then((response) => response.json())
        .then((details) => save(details.variants?.find((variant) => variant.available)?.id))
        .catch(() => save());
    };
    add.availableVariantPatch = true;
    swat.addToWishlistUsingDu = add;

    if (typeof removeFromWishlistUsingDu !== 'function') return;
    swat.removeFromWishlistUsingDu = function (product, onSuccess, onError) {
      if (!product?.du) return removeFromWishlistUsingDu.apply(this, arguments);

      const fallback = () => removeFromWishlistUsingDu.call(this, product, onSuccess, onError);
      swat.fetchLists({
        callbackFn: (lists) => {
          const handle = handleOf(product.du);
          const epis = lists
            .flatMap((list) => list.listcontents || [])
            .filter((item) => handleOf(item.du) === handle)
            .map((item) => item.epi);
          if (!epis.length) return fallback();
          epis.forEach((epi, index) => {
            const last = index === epis.length - 1;
            removeFromWishlistUsingDu.call(this, { ...product, epi }, last ? onSuccess : noop, last ? onError : noop);
          });
        },
        errorFn: fallback,
      });
    };
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.('.swym-wishlist-collections-v2');
      if (!button) return;
      if (window._swat) patch(window._swat);

      const saving = button.getAttribute('aria-pressed') !== 'true';
      button.classList.toggle('is-saving', saving);
      button.classList.toggle('is-removing', !saving);
    },
    true
  );
})();
